import { GenericInputSearchStyle } from './styles';

const GenericInputSearch = ({ ...props }: any) => {
  return <GenericInputSearchStyle {...props} />;
};

export default GenericInputSearch;
